export const siteConfig = {
  siteName: "Luxury Golden Triangle Tour",
  siteUrl: "https://www.luxurygoldentriangle.com",
  wordpressApiUrl: "https://luxurygoldentriangle.com/bkadmn/wp-json/wp/v2",
  defaultImage: "/Luxury-Golden-Triangle-Flower.png",
  twitterHandle: "",
};
export const defaultSeo = {
  title: "Luxury Golden Triangle Tour",
  description:
    "Plan your ultimate private Golden Triangle tour through Delhi, Agra, Jaipur and beyond — tailored hotels, expert guides and authentic India experiences crafted just for you.",
  keywords:
    "Luxury Golden Triangle, Golden Triangle Tour India, Private India Tours, Delhi Agra Jaipur Tour, Luxury India Travel",
  type: "website",
};

export const routeSeo = {
  "/": {
    wpSlug: "home-2",
    title: "Luxury Golden Triangle Tour - Best Golden Triangle India Tour",
    description:
      "Experience the Golden Triangle in ultimate luxury — private tours through Delhi, Agra & Jaipur with handpicked hotels, expert guides and bespoke itineraries crafted just for you.",
    keywords:
      "Luxury Golden Triangle Tours, Delhi Agra Jaipur Tour, Private Golden Triangle India, luxury India Tour Packages",
  },
  "/about-us": {
    title: "About Us - Luxury Golden Triangle Tour",
    description:
      "Meet the boutique team behind Luxury Golden Triangle — passionate travel experts crafting deeply personal Golden Triangle journeys, luxury stays and authentic Indian experiences.",
    keywords:
      "about Luxury Golden Triangle, Best India travel Company, Best Luxury Travel Company for India Tour, Golden Triangle Tour Experts, Boutique India Tours, Best Indian DMC",
  },
  "/tours": {
    title: "Golden Triangle Tours - Luxury Golden Triangle Tour",
    description:
      "From short escapes to immersive Oberoi journeys and tiger safaris — explore our private Golden Triangle tour packages and find the perfect India experience for you.",
    keywords:
      "Golden Triangle tour packages, luxury Golden Triangle tours, Delhi Agra Jaipur packages, India Private Tours, Luxury Rajasthan Tour",
  },
  "/luxury-golden-triangle-enquiry": {
    title: "Enquiry - Luxury Golden Triangle Tour",
    description:
      "Share your travel dreams and we'll craft a bespoke Luxury Golden Triangle itinerary — handpicked hotels, private vehicles, expert guides and experiences made for you.",
    keywords:
      "tailor made Golden Triangle Tour, luxury India Tour, Private India Tour, Custom Golden Triangle Tour",
  },
  "/video-reviews": {
    title: "Video Reviews - Luxury Golden Triangle Tour",
    description:
      "Hear it straight from our guests — watch real video reviews from travellers who've experienced private Luxury Golden Triangle tours across Delhi, Agra and Jaipur.",
    keywords:
      "Luxury Golden Triangle reviews, Golden Triangle Tour testimonials, India Tour video reviews",
  },
  "/contact": {
    title: "Contact Us - Luxury Golden Triangle Tour",
    description:
      "Ready to start planning? Reach out to the Luxury Golden Triangle team to discuss your private India tour, ask questions or receive a personalised travel proposal.",
    keywords:
      "contact Luxury Golden Triangle, India Tour enquiry, Golden Triangle Travel contact, Best India Tour Company",
  },
  "/authentic-indian-experiences": {
    title: "Authentic Indian Experiences - Luxury Golden Triangle Tour",
    description:
      "Go beyond the sights — enrich your Golden Triangle tour with immersive Indian experiences including local markets, cooking classes, village visits, art and cultural traditions.",
    keywords:
      "authentic Indian experiences, India cultural tours, Golden Triangle experiences, local India travel, India Food Tour, India Cooking Class",
  },
  "/5-star-luxury-hotels": {
    title: "Luxury Hotels List - Luxury Golden Triangle Tour",
    description:
      "Rest in style — browse our carefully selected luxury and heritage hotels in Delhi, Agra and Jaipur, each chosen to elevate your private Golden Triangle experience.",
    keywords:
      "5 star hotels Golden Triangle, luxury hotels Delhi Agra Jaipur, India heritage hotels, Golden Triangle hotel list",
  },
  "/car-details": {
    title: "Car Details - Luxury Golden Triangle Tour",
    description:
      "Travel in complete comfort — explore our private vehicle options for your Golden Triangle tour, from premium cars to luxury upgrades for a seamless India journey.",
    keywords:
      "Golden Triangle tour cars, luxury cars India tour, private car Delhi Agra Jaipur, India travel vehicles, Private driver and car India",
  },
  "/golden-triangle-short-tour": {
    title: "GOLDEN TRIANGLE - SHORT TOUR - Luxury Golden Triangle Tour",
    description:
      "Make the most of limited time — our private 3 nights 4 days Golden Triangle short tour whisks you through Delhi, Agra and Jaipur with curated sightseeing and seamless travel.",
    keywords:
      "Golden Triangle short tour, Agra Jaipur tour from Delhi, 3 nights 4 days Golden Triangle, Delhi Agra Jaipur short trip",
  },
  "/golden-triangle-standard-tour": {
    title: "GOLDEN TRIANGLE - STANDARD TOUR - Luxury Golden Triangle Tour",
    description:
      "Savour India at a relaxed pace — our private 6 nights 7 days Golden Triangle tour takes you through Delhi, Agra and Jaipur with expert guides, luxury hotels and local experiences.",
    keywords:
      "Golden Triangle standard tour, 6 nights 7 days India tour, Delhi Agra Jaipur itinerary",
  },
  "/golden-triangle-oberoi-hotels": {
    title: "GOLDEN TRIANGLE - OBEROI HOTELS - Luxury Golden Triangle Tour",
    description:
      "Indulge in India's finest — experience the Golden Triangle staying at iconic Oberoi hotels in Delhi, Agra and Jaipur with private travel and expert local guides throughout.",
    keywords:
      "Golden Triangle Oberoi hotels, luxury Oberoi India tour, Oberoi Delhi Agra Jaipur, luxury Golden Triangle itinerary",
  },
  "/golden-triangle-tiger-tour": {
    title: "GOLDEN TRIANGLE & TIGER TOUR - Luxury Golden Triangle Tour",
    description:
      "Culture meets wilderness — combine the iconic cities of Delhi, Agra and Jaipur with a thrilling private tiger safari at Ranthambhore National Park on one unforgettable India journey.",
    keywords:
      "Golden Triangle Tiger tour, Ranthambhore safari tour, India wildlife and culture tour, Delhi Agra Jaipur tiger safari",
  },
  "/best-luxury-private-india-tour": {
    title: "Best Luxury Private India Tour - Luxury Golden Triangle Tour",
    description:
      "Discover India at its most magnificent — a private journey through Delhi, Agra, Jaipur, Rawla Narlai and Udaipur with optional extensions to Varanasi or Kerala.",
    keywords:
      "Best luxury private India tour, Best of India tour, private India itinerary, Delhi Agra Jaipur Udaipur tour, luxury Rajasthan tour, Rajasthan and Kerala Luxury Tour",
  },
  "/blog": {
    title: "Blog - Luxury Golden Triangle Tour",
    description:
      "Fuel your India wanderlust — read our latest travel articles, hotel inspiration, insider tips and journey ideas for Delhi, Agra, Jaipur and beyond.",
    keywords:
      "Golden Triangle blog, India travel tips, Delhi Agra Jaipur travel, luxury India tour blog",
  },
  "/terms-conditions": {
    title: "Terms and Conditions - Luxury Golden Triangle Tour",
    description:
      "Everything you need to know before you travel — review the booking terms and conditions for your Luxury Golden Triangle tour.",
    keywords:
      "Luxury Golden Triangle terms, India tour terms conditions, travel booking policy",
  },
  "/golden-triangle-tour-extensions": {
    title: "Golden Triangle Tour Extensions - Luxury Golden Triangle Tour",
    description:
      "Why stop at three cities? Extend your Golden Triangle journey with handpicked India destinations and experiences tailored around your schedule, interests and travel style.",
    keywords:
      "Golden Triangle tour extensions, extend India tour, Rajasthan extension, India private tour add ons",
  },
  "/tailor-made-private-tour": {
    title: "Luxury Golden Triangle Tours | Bespoke. Private. Unforgettable.",
    description:
      "Experience Delhi, Agra & Jaipur in absolute luxury. Fully bespoke, private itineraries with chauffeured travel, 5-star & heritage hotels, and a dedicated travel expert — crafted around you.",
    keywords:
      "Golden triangle Tour, bespoke Golden triangle Tour, Delhi, Aagra, Jaipur Tour",
  },  
};
